<template>
  <div class="radio-refined">
    <div v-for="(option, index) in options" :key="index" class="radio-refined-item">
      <input
        @change="change(option)"
        type="radio"
        :id="option.title"
        :value="option.value"
        :name="name"
        :checked="index == 0"
      />
      <label class="radio-refined-control" :for="option.title">
        {{ option.title }}
      </label>
    </div>
  </div>
</template>

<script>
export default {
  props: ['name', 'options'],
  methods: {
    change(obj) {
      this.$emit('input', obj);
    }
  }
};
</script>

<style lang="scss">
.radio-refined {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 32px;
  background-color: rgba(#00ce7c, 0.5);
  width: 100%;
  flex-direction: column;

  @media (min-width: 768px) {
    width: auto;
    flex-direction: row;
    height: 48px;
  }

  &-item {
    width: 100%;
    position: relative;

    @media (min-width: 768px) {
      width: auto;
    }

    input {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;

      &:focus + label {
        box-shadow: 0 0 0 3px rgba(#18316b, 0.2);
        background-color: rgba(#18316b, 0.5);
      }

      &:checked + label {
        background-color: #18316b;
      }
    }
  }

  &-control {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 48px;
    border-radius: 32px;
    padding: 8px 32px;
    color: #fff;
    font-weight: 600;
    font-size: 14px;
    transition: 0.2s all ease;
  }
}
</style>
